// Basic Methods
function navigateToDashboard() {
    window.location.href = '/';
}

function openSupportWidget() {
    if (!window.OpenWidget || typeof window.OpenWidget.call !== "function") {
        throw new Error("Support widget is not available.");
    }

    window.OpenWidget.call("maximize");
}

function addEscapeKeyListener(dotnetHelper) {
    function escapeKeyHandler(event) {
        if (event.key === "Escape" || event.keyCode === 27) {
            dotnetHelper.invokeMethodAsync("CloseOnEscape");
        }
    }

    window.addEventListener("keydown", escapeKeyHandler);

    return {
        dispose: function () {
            window.removeEventListener("keydown", escapeKeyHandler);
            console.log("disposed event")
        }
    };
}

// Window Dimensions
getWindowHeight = function () {
    return window.innerHeight;
};

getWindowWidth = function () {
    return window.innerWidth;
};

// Get Image Dimensions
window.getImageDimensions = (dataUrl, targetWidth = 512, targetHeight = 512) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            let width = targetWidth;
            let height = targetHeight;


            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');


            ctx.drawImage(img, 0, 0, width, height);


            const resizedDataUrl = canvas.toDataURL();


            resolve({ width, height, resizedDataUrl });
        };
        img.onerror = () => {
            reject(new Error('Failed to load image'));
        };
        img.src = dataUrl;
    });
};